import { Component } from '@angular/core';
import {
  TUser,
  UserAccessLevel,
  UserLevel,
  UserStatus,
} from '@shared/interfaces/TUser';

@Component({
  selector: 'app-users-batch-update',
  templateUrl: './users-batch-update.component.html',
  styleUrls: ['./users-batch-update.component.scss'],
})
export class UsersBatchUpdateComponent {
  // TODO: check if we need this mocked data
  public newUserData: TUser = {
    categories: [],
    countries: [],
    email: `pch@pp.pl`,
    firstName: `Piotr`,
    lastName: `Chwirot`,
    level: UserLevel.User,
    userAccessLevel: UserAccessLevel.KAM,
    password: `password`,
    projects: [],
    projectsRegions: [],
    status: UserStatus.Active,
  };
}
